import { useState } from 'react';
import api from '../../../../data/api';

export const useVideoData = ({
	startIndex,
	itemsPerPage,
	selectedTags,
	selectedDurations,
	selectedLevels,
	selectedInstructors,
	selectedProducts,
	sortBy,
	setTotalVideos,
	userData
}) => {
	const [responseData, setResponseData] = useState([]);
	const categoryId = '6541e9f2f1f99641d644a35a';

	const fetchVideosByFilters = async () => {
		try {
			const userId = userData?.user?.userId || '';
			const endIndex = startIndex + itemsPerPage - 1;

			// Format filters for API request
			const selectedTagsIds = selectedTags?.map(tag => tag).join(',');
			const durations = selectedDurations?.map(duration => duration).join(',');
			const levels = selectedLevels?.map(level => level).join(',');

			const response = await api.getSingleFilteredVideos({
				startIndex,
				endIndex,
				selectedTags: selectedTagsIds,
				selectedDurations: durations,
				selectedLevels: levels,
				sortby: sortBy || 'latest',
				selectedInstructors,
				selectedProducts,
				userId,
				categoryId
			});
			
			// Calculate total pages for pagination
			if (response.data.libraryVideosData[0]?.totalRecords) {
				
				setTotalVideos(Math.ceil(response.data.libraryVideosData[0].totalRecords / itemsPerPage));
			}

			setResponseData(response.data.libraryVideosData);
		} catch (error) {
			console.error('Error fetching data: ', error);
		}
	};

	// Helper function to update video state after liking/unliking
	const updateVideoLikeStatus = (videoId, isLiked) => {
		setResponseData(prevData => {
			return prevData.map(category => {
				const updatedVideos = category.videos.map(video => {
					if (video?.videoDetails?._id === videoId) {
						return {
							...video,
							videoDetails: {
								...video.videoDetails,
								savedvideo: isLiked
							}
						};
					} else if (video?._id === videoId) {
						return {
							...video,
							savedvideo: isLiked
						};
					}
					return video;
				});

				return {
					...category,
					videos: updatedVideos
				};
			});
		});
	};

	return {
		responseData,
		fetchVideosByFilters,
		updateVideoLikeStatus,
		setResponseData
	};
};
